const statusCheck = (status) => {
    if (status === 401){
        window.location.replace("/");
    }
}
export default statusCheck;
